import {
    FETCH_UPDATE_SEARCHER_REQUEST,
    FETCH_UPDATE_SEARCHER_SUCCESS,
    FETCH_UPDATE_SEARCHER_FAILURE,
    SET_UPDATE_SEARCHER
} from '../../actions/searchers/update-searchers-actions';

const initialState = {
    updatedSearcher: null,
    searcher: null,
    isLoading: false,
    error: null,
};

const CLEAR_DATA = "CLEAR_DATA";
const UpdateSearcherReducer = (state = initialState, action: any) => {
    switch (action.type) {
        case FETCH_UPDATE_SEARCHER_REQUEST:
            return {
                ...state,
                isLoading: true,
                error: null,
            };
        case SET_UPDATE_SEARCHER:
            return {
                ...state,
                isLoading: false,
                error: null,
                searcher: { ...action.payload }
            };
        case FETCH_UPDATE_SEARCHER_SUCCESS:
            return {
                ...state,
                isLoading: false,
                updatedSearcher: action.payload[0],
            };
        case FETCH_UPDATE_SEARCHER_FAILURE:
            return {
                ...state,
                isLoading: false,
                error: action.payload,
            };
        case CLEAR_DATA:
            return {
                ...initialState
            };
        default:
            return state;
    }
};

export default UpdateSearcherReducer;